import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ScheduleAppointmentRequestV2, ScheduleAppointmentResponse } from '@src/lib/__generated/api';
import restfulClient from '@src/utils/restfulClient';

export async function scheduleAppointment(body: ScheduleAppointmentRequestV2) {
	// NOTE: "v2" here is NOT related to the versioning of this FE application, this is for web API
	const route = `v2/facilities/appointments`;

	try {
		const data: ScheduleAppointmentResponse = await restfulClient.post({ route, data: body });
		return data;
	} catch (error) {
		const message =
			'There has been an error. Please try again, or call us at (800) 277-3633 to schedule your appointment.';
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data.Errors ?? message);
		} else {
			throw new Error(message);
		}
	}
}

export function useScheduleAppointment() {
	const { isPending, mutate } = useMutation<ScheduleAppointmentResponse, Error, ScheduleAppointmentRequestV2>({
		mutationKey: ['scheduleAppointment'],
		mutationFn: (body) => scheduleAppointment(body),
	});
	return { isPending, mutate };
}
